import "./DebugReviewArea.scss";

import React from "react";

import { CardData } from "../CardData";
import Card from "./Card";

export default function DebugReviewArea({
  cardDatas,
}: {
  cardDatas: CardData[];
}) {
  return (
    <div className="DebugReviewArea">
      {cardDatas.map(cardData => (
        <div>
          <p>
            card ID: <pre>{cardData.cardID}</pre>
          </p>
          <div className="DebugCardContainer">
            {(cardData.cardType === "basic"
              ? [cardData]
              : cardData.prompts
            ).map((
              promptData, // TODO remove metric duplication with Card.scss
            ) => (
              <div className="DebugPromptWrapper">
                <Card
                  promptData={promptData}
                  cardType={cardData.cardType}
                  cardState={null}
                  isRevealed={true}
                  reviewMarkingInteractionState={null}
                  schedule="default"
                  shouldLabelApplicationPrompts={true}
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
